import {
  ApplicationView,
  StartControllerScope,
  useController,
} from '@aha-app/mvc';
import { InplaceField } from '@aha-app/react-in-place';
import React, { useCallback } from 'react';
import { CustomRecordSelectorController } from './CustomRecordSelectorController';
import { type SelectroCallback } from '@aha-app/selectro-v2';
import SelectroV2InPlaceTagsTriggerTemplate from '../../../SelectroV2/Templates/SelectroV2TagsTriggerTemplate/SelectroV2InPlaceTagsTriggerTemplate';

/**
 * This component is a custom record selector that allows users to select from multiple records.
 * It's primary use case if for selecting records from a custom RecordsField
 */
const CustomRecordSelector: React.FC = () => {
  const controller = useController(CustomRecordSelectorController);
  const { className, editable, value, selectroProps, ...props } =
    controller.props;

  const handleSelectroSelect: SelectroCallback<'select'> = useCallback(
    ({ selected }) => {
      controller.actionChangeRecords(selected || []);
    },
    [controller]
  );

  const handleSelectroClearAll: SelectroCallback<'clearAll'> =
    useCallback(() => {
      controller.actionChangeRecords([]);
    }, [controller]);

  return (
    <InplaceField
      {...props}
      {...selectroProps}
      includeDataInSelectedItems
      type='selectro'
      selectroType='multiple'
      tabIndex='1'
      class={className}
      value={value}
      callbacks={{
        select: handleSelectroSelect,
        clearAll: handleSelectroClearAll,
      }}
      disabled={!editable}
      templates={internalProps => ({
        ...selectroProps.templates,
        trigger: ({ items }) => {
          return (
            <SelectroV2InPlaceTagsTriggerTemplate
              callSelectCallbackOnRemove
              noneSelected={selectroProps.text.noneSelected}
              items={items}
              editable={editable}
              class={internalProps.class}
              showInput={internalProps.showInput}
              focusing={internalProps.focusing}
            />
          );
        },
      })}
    />
  );
};

export default StartControllerScope(
  CustomRecordSelectorController,
  ApplicationView(CustomRecordSelector)
);
